export const cameraView05DeckTopImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 05 - Deck top',
  staticOptions: {
    HullTreatment: 1,
    TeakOnBathingPlatform: 1,
    Boom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView05DeckTop.js